import { useEffect } from "react";

import { formatDate } from "@/utils/dateFormatter";
import { useSyncIntegration } from "@/hooks/integrations/useIntegration";
import CustomModalForm from "@/components/desktop/form/modal/CustomModalForm/CustomModalForm";
import CustomButton from "@/components/desktop/button/CustomButton";

import IntegrationOC from "./IntegrationOC";
import IntegrationSale from "./IntegrationSale";
import IntegrationDelivery from "./IntegrationDelivery";

import classes from "./integration.module.scss";

const INTEGRATION_COMPONENTS = {
	sapbo: [
		{ Component: IntegrationOC, getProps: (s) => ({ completeOrder: s.orders.done, messageOrder: s.orders.message }) },
		{
			Component: IntegrationDelivery,
			getProps: (s) => ({ completeOrder: s.orders.done, completeOrderDelivery: s.delivery.done, messageOrderDelivery: s.delivery.message }),
		},
		{
			Component: IntegrationSale,
			getProps: (s) => ({
				completeOrder: s.orders.done,
				completeOrderDelivery: s.delivery.done,
				completeOrderSale: s.sale.done,
				messageOrderSale: s.sale.message,
			}),
		},
	],
	nisira: [
		{ Component: IntegrationOC, getProps: (s) => ({ completeOrder: s.orders.done, messageOrder: s.orders.message }) },
		{
			Component: IntegrationDelivery,
			getProps: (s) => ({ completeOrder: s.orders.done, completeOrderDelivery: s.delivery.done, messageOrderDelivery: s.delivery.message }),
		},
	],
	agri: [
		{
			Component: IntegrationDelivery,
			getProps: (s) => ({ completeOrder: s.orders.done, completeOrderDelivery: s.delivery.done, messageOrderDelivery: s.delivery.message }),
		},
		{
			Component: IntegrationSale,
			getProps: (s) => ({
				completeOrder: s.orders.done,
				completeOrderDelivery: s.delivery.done,
				completeOrderSale: s.sale.done,
				messageOrderSale: s.sale.message,
			}),
		},
	],
	softland: [{ Component: IntegrationOC, getProps: (s) => ({ completeOrder: s.orders.done, messageOrder: s.orders.message, text: "Documentos" }) }],
	softland_connector: [{ Component: IntegrationOC, getProps: (s) => ({ completeOrder: s.orders.done, messageOrder: s.orders.message, text: "Documentos" }) }],
	odoo: [{ Component: IntegrationOC, getProps: (s) => ({ completeOrder: s.orders.done, messageOrder: s.orders.message, text: "Documentos" }) }],
};

const IntegrationLoad = ({ integrationSelect }) => {
	const { syncState, runSync } = useSyncIntegration();

	const handleComplete = () => {
		window.location.reload();
	};

	useEffect(() => {
		if (integrationSelect.show) {
			runSync({ integration: integrationSelect.integration, file: integrationSelect.file });
		}
	}, [integrationSelect, runSync]);

	const components = INTEGRATION_COMPONENTS[integrationSelect.integration] ?? [];

	return (
		<CustomModalForm
			open={integrationSelect.show}
			title={`Sincronizando registros desde ${integrationSelect.name}`}
			isLoading={!syncState.finished}
			onClose={handleComplete}
			closeOnEsc={false}
			footer={
				syncState.finished ? (
					<CustomButton variant="primary" onClick={handleComplete}>
						Actualizar Listado
					</CustomButton>
				) : (
					false
				)
			}
			gridTable={false}
			size="sm"
		>
			<div className={classes.integrationModal}>
				<span style={{ fontSize: "13px" }}>Se sincronizaran los registros actualizados a la fecha {formatDate(new Date())}.</span>

				{components.map(({ Component, getProps }, index) => (
					<Component key={index} {...getProps(syncState)} />
				))}
			</div>
		</CustomModalForm>
	);
};

export default IntegrationLoad;
